// https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
import {IPublicClientApplication, PublicClientApplication} from "@azure/msal-browser";
import { ApiKeys, ApiService, APP_BASE_URL } from "../constants";

const msalConfig = {
  auth: {
    clientId: ApiKeys.azureAD_client_id,
    authority: ApiService.azureAd.instance + ApiKeys.azureAD_tenant_id,
    redirectUri: APP_BASE_URL,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
  prompt: 'select_account',
  loginHint: null
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const directTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};

export const redirectToAzureAD = (directType: string, instance: IPublicClientApplication, callback?: any) => {
  // Register Callbacks for redirect flow
  instance.handleRedirectPromise()
    .then(response => {
      sessionStorage.removeItem("msal.interaction.status")
      if (typeof (callback) === "function") {
        callback(response, true);
      }

      if (directType == directTypes.LOGIN) {
        instance.loginRedirect(loginRequest);
      }
    })
    .catch(error => {
      console.log(error);
      if (typeof (callback) === "function") {
        callback(null, false);
      }
    });
};
